module.exports = __webpack_public_path__ + "img/yoga.219bf07f.png";